import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { GsdSupportService } from '../services/Organization/gsd-support-dialog.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-gsd-support-dialog',
  templateUrl: './gsd-support-dialog.component.html',
  styleUrls: ['./gsd-support-dialog.component.css']
})
export class GsdSupportDialogComponent {
  supportForm: FormGroup;
  isSubmitting = false;
  allowedLogoExtentions: string = '.png,.jpeg,.jpg,.pdf';
  logo: File | null = null;
  formData: any;

  @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private fb: FormBuilder,
    private supportService: GsdSupportService,
    public dialogRef: MatDialogRef<GsdSupportDialogComponent>,
    private toaster: ToastrService
  ) {
    this.supportForm = this.fb.group({
      subject: ['', Validators.required],
      comment: ['', Validators.required]
    });
  }

  submit(): void {
    if (this.supportForm.invalid || this.isSubmitting) return;

    this.isSubmitting = true;

    const formData = new FormData();
    formData.append('subject', this.supportForm.value.subject);
    formData.append('comment', this.supportForm.value.comment);
    if (this.logo) {
      formData.append('Screenshot', this.logo, this.logo.name);
    }

    this.supportService.sendSupportRequest(formData).subscribe({
      next: () => {
        this.toaster.success('Thanks for your feedback. The GSD Support team will contact you soon.');
        this.dialogRef.close();
      },
      error: (err) => {
        this.toaster.error('Failed to send support request.');
        console.error(err);
      },
      complete: () => this.isSubmitting = false
    });
  }
  getTruncatedFileName(name: string, maxLength: number = 30): string {
    if (!name) return '';
    if (name.length <= maxLength) return name;

    const extIndex = name.lastIndexOf('.');
    const extension = extIndex !== -1 ? name.substring(extIndex) : '';
    const baseName = name.substring(0, extIndex !== -1 ? extIndex : maxLength);

    return baseName.substring(0, maxLength - extension.length - 3) + '...' + extension;
  }
  onFileChange(fileList: FileList | null): void {
    if (fileList && fileList.length > 0) {
      this.logo = fileList[0];
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

      if (!allowedTypes.includes(this.logo.type)) {
        this.toaster.error('File type not supported. Please upload only JPG, PNG, or PDF files.');
        this.RemoveLogo();
        return;
      }
      const maxSize = 2 * 1024 * 1024;
      if (this.logo.size > maxSize) {
        this.toaster.error('File size exceeds 2 MB. Please upload a smaller file.');
        this.RemoveLogo();
        return;
      }
      this.supportForm.get('screenshot')?.setValue(this.logo);
      this.supportForm.get('screenshot')?.markAsTouched();
      this.supportForm.get('screenshot')?.updateValueAndValidity();
    }
  }

  RemoveLogo() {
    this.logo = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.onFileChange(event.dataTransfer.files);
    }
  }
}
